export default __webpack_public_path__ + "static/118-4f1c64bc76b0784af2ad7d10fd58a24e.gif";